<template>
  <!-- banner topo-->
  <div v-if="produtosDetalhe != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 ">
            <div class="hero-caption hero-caption2">
              <h2>{{ produtosDetalhe.itiNome }}{{ produtosDetalhe.itiReferencia }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Banner -->

  <!-- detalhes -->
  <section class="services-area gray-bg section-padding">
    <div class="container">
      <!-- detalhes -->
          <div class="">
            <div v-if="ListaCaracteristicas != ''" class="row d-flex carac-sep">

              <div v-for="detalhes in ListaCaracteristicas" :key="detalhes.igsId" class="row col-md-3">
                <div class="single-defination" style="justify-content: center; text-align: center;">
                  <div><img src="/favicon.png" style="width: 80px; height: auto; padding-bottom: 15px;" /></div>
                  <h4 class="mb-20 linha">{{ detalhes.igsNome }}</h4>
                  <p v-html="detalhes.igsResumo" style="padding-top: 10px;"></p>
                </div>
              </div>

            </div>
          </div>
    </div>
  </section>
  <!-- END detalhes -->

  <!-- textos imagem 1 -->
  <section class="project-us section-padding ">
    <div class="container">
      <div v-if="produtosDetalhe != ''" class="row sobre-alinhar">
        <!-- txt -->
        <div class=" col-md-6">
          <div class="section-tittle ">
            <p v-html="produtosDetalhe.itiResumo1"></p>
          </div>
        </div>
        <!--img -->
        <div class="col-md-6">
          <div class="produtos-1"
            :style="{ backgroundImage: 'url(' + $imgURL + produtosDetalhe.insInstitucionalImagens[0].itgUrlImagem + ')' }">
          </div>
        </div>
      </div>

    </div>
  </section>
  <!-- END textos imagem 1 -->

  <!-- textos imagem 2 -->
  <section class="project-us section-padding hidden-sm hidden-lg">
    <div class="container">
      <div v-if="produtosDetalhe != ''" class="row sobre-alinhar">
                <!-- txt -->
        <div class=" col-md-6">
          <div class="section-tittle txt-produto">
            <p v-html="produtosDetalhe.itiResumo2"></p>
          </div>
        </div>
        <!-- img -->
        <div class="col-md-6">
          <div class="produtos-2"
            :style="{ backgroundImage: 'url(' + $imgURL + produtosDetalhe.insInstitucionalImagens[1].itgUrlImagem + ')' }">
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="project-us section-padding hidden-xs hidden-md">
    <div class="container">
      <div v-if="produtosDetalhe != ''" class="row sobre-alinhar">
        <!-- img -->
        <div class="col-md-6">
          <div class="produtos-2"
            :style="{ backgroundImage: 'url(' + $imgURL + produtosDetalhe.insInstitucionalImagens[1].itgUrlImagem + ')' }">
          </div>
        </div>
        <!-- txt -->
        <div class=" col-md-6">
          <div class="section-tittle txt-produto">
            <p v-html="produtosDetalhe.itiResumo2"></p>
          </div>
        </div>
      </div>

    </div>
  </section>
  <!-- END textos imagem 2 -->

  <!-- planos -->
  <section>
    <div v-if="produtosDetalhe != '' && ListaPlanos.length > 0" class="support-company-area bottom-padding">
      <div class="container">
        <section class="pricing">
          <div class="row" style="gap: 30px;">
            <div v-for="planos in ListaPlanos" :key="planos.igsId" class="col-md-4 pricing-plan">
              <h2 class="class-plan-title">{{ planos.igsNome }}</h2>
              <h6 v-html="planos.igsResumo" class=" txt-branco">
              </h6>
              <!-- Button -->
              <div class="buttons">
                <ul>
                  <li class="button-header-avance">
                    <router-link to="/contato" class="white-btn header-btn2">Contato</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>

  <!-- call to action -->
  <PageCallAction></PageCallAction>
  <!-- call to action -->

</template>

<script>

import { useHead } from '@vueuse/head'
import axios from 'axios'
import PageCallAction from '@/components/PageCallAction.vue';
import { useRoute } from 'vue-router';

export default {
  name: 'ProdutosDetalheView',
  components: {
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome,
    };
  },

  data: () => ({
    produtos: [],
    apresentacaoDetalhes: [],
    planos: [],
    ListaPlanos: [],
    ListaCaracteristicas: [],
    produtosDetalhe: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    //aqui busca filtra os planos
    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.produtosDetalhe = response.data;
        this.carregaMetas(this.removerTagsHTML(this.produtosDetalhe.itiResumo1,this.produtosDetalhe.itiNome));
        this.ListaCaracteristicas = this.produtosDetalhe.insInstitucionalGrids.filter(x => x.insListaGaleriaInstGrids.lgtId == 6);
        this.ListaPlanos = this.produtosDetalhe.insInstitucionalGrids.filter(x => x.insListaGaleriaInstGrids.lgtId == 5);
        //console.log('produtosDetalhe')
        //console.log(this.produtosDetalhe)
        //  console.log('ListaCaracteristicas')
       // console.log(this.ListaCaracteristicas)
       //   console.log('ListaPlanos')
       // console.log(this.ListaPlanos)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>